import React from 'react'
import { NavLink } from "react-router-dom";
import classNames from "classnames/bind"

import styles from "./desktop-header.module.scss"

const cx = classNames.bind(styles)

export const DesktopHeader = ({navigationItems, redirectRoute, displayContactModal}) => {
    return (
        <nav className={cx('desktop')}>
            <ul>
                {navigationItems.map( (nav, index) => {
                    return (
                        <li key={index}>
                            <NavLink to={nav.link} activeClassName={cx("selected")} exact={nav.exact}>
                                {nav.text}
                                {nav.subNav && <span className={cx("arrow-down")}></span>}
                            </NavLink>
                            {nav.subNav &&
                                <ul className={cx('sub-navigation')}>
                                    {nav.subNav.map( (subNav, index) => {
                                        return (
                                            <li onClick={() => redirectRoute(subNav.link)} key={index}>
                                                <NavLink to={subNav.link} activeClassName={cx('selected')}>{subNav.text}</NavLink>
                                            </li>
                                        )
                                    })}
                                </ul>
                            }
                        </li>
                    )
                })}
                {/*<li onClick={() => displayContactModal()}>*/}
                {/*    <a href="#">Contact</a>*/}
                {/*</li>*/}
            </ul>
        </nav>
    )
}